<template>
  <div class="transport-grid">
    <div class="ibox">
      <div class="ibox-content">
        <div v-if="weights.length" class="table-responsive">
          <table class="table table-bordered table-sm transport-grid__table">
            <thead>
              <tr>
                <th class="transport-grid__corner">Poids</th>
                <th v-for="(zone, index) in zones" :key="zone" class="transport-grid__zone">
                  Zone {{ index + 1 }}
                  <small>jusqu'à {{ zone }} km</small>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(weight, index) in weights" :key="weight">
                <th class="transport-grid__weight">{{ weightLabel(index) }}</th>
                <td
                  v-for="zone in zones"
                  :key="zone"
                  class="transport-grid__cell"
                  :class="{ 'is-editable': canEdit && !!rateAt(zone, weight) }"
                  @click="editCell(zone, weight)"
                >
                  <template v-if="rateAt(zone, weight)">
                    {{ rateAt(zone, weight).price }} <span class="transport-grid__unit">€</span>
                  </template>
                  <span v-else class="transport-grid__empty">&mdash;</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <p v-else class="text-muted mb-0">Aucun tarif enregistré.</p>

        <p v-if="canEdit && weights.length" class="transport-grid__hint">
          <i class="far fa-info-square"></i>
          Cliquez sur un prix pour le modifier.
        </p>
      </div>
    </div>

    <!-- Même modale que la vue liste : les deux présentations éditent via le même
         formulaire, il n'y a qu'une façon de modifier un tarif. -->
    <AdminModalForm
      id="transport_rate_grid_modal"
      :config="config"
      :id_to_edit="idToEdit"
      @submit:update:success="onSaved"
      @submit:create:success="onSaved"
    />
  </div>
</template>

<script>
import AdminModalForm from "@/components/Global/AdminModalForm";
import config from "./config";

export default {
  name: "TransportRateGrid",
  components: {
    AdminModalForm,
  },
  data() {
    return {
      config: config,
      idToEdit: null,
    };
  },
  computed: {
    canEdit() {
      return this.$root.isAuthorized("transport-rate_edit");
    },
    rates() {
      return this.$store.getters["transport_rate/getAll"];
    },
    zones() {
      return this.distinctSorted("zone_km_max");
    },
    weights() {
      return this.distinctSorted("weight_max");
    },
    // Index (zone|poids) -> tarif, pour éviter un find() par cellule.
    ratesByCell() {
      return this.rates.reduce((index, rate) => {
        index[rate.zone_km_max + "|" + rate.weight_max] = rate;
        return index;
      }, {});
    },
  },
  created() {
    this.$store.dispatch("transport_rate/getAll");
  },
  methods: {
    distinctSorted(field) {
      return [...new Set(this.rates.map((rate) => rate[field]))].sort((a, b) => a - b);
    },
    rateAt(zone, weight) {
      return this.ratesByCell[zone + "|" + weight];
    },
    // Le palier va de la borne précédente à la sienne : le premier part du seuil
    // Chronopost, qui est en deçà de la grille.
    weightLabel(index) {
      const max = this.weights[index];
      if (index === 0) {
        return "jusqu'à " + max + " kg";
      }
      return this.weights[index - 1] + " à " + max + " kg";
    },
    editCell(zone, weight) {
      const rate = this.rateAt(zone, weight);
      if (!this.canEdit || !rate) {
        return;
      }
      this.idToEdit = rate.id;
      this.$root.$emit("bv::show::modal", "transport_rate_grid_modal");
    },
    onSaved() {
      this.$root.$emit("bv::hide::modal", "transport_rate_grid_modal");
      this.idToEdit = null;
      this.$store.dispatch("transport_rate/getAll", true);
    },
  },
};
</script>

<style lang="scss" scoped>
.transport-grid {
  &__table {
    margin-bottom: 0;
    text-align: center;
  }

  // Le thème force .table th en 9px majuscules gris : on rétablit une taille lisible
  // et la casse normale pour tous les en-têtes de cette grille.
  &__corner,
  &__zone,
  &__weight {
    background-color: #f5f5f6;
    vertical-align: middle !important;
    font-size: 13px;
    text-transform: none;
    color: #333;
  }

  &__zone {
    white-space: nowrap;

    small {
      display: block;
      margin-top: 2px;
      font-size: 12px;
      font-weight: 400;
      color: #888;
    }
  }

  &__weight {
    text-align: left;
    white-space: nowrap;
    font-weight: 600;
  }

  &__cell {
    vertical-align: middle !important;
    white-space: nowrap;
    font-size: 13px;
    color: #333;

    &.is-editable {
      cursor: pointer;
      transition: background-color 0.15s ease;

      &:hover {
        background-color: rgba(26, 179, 148, 0.1);
      }
    }
  }

  &__unit {
    color: #999;
  }

  &__empty {
    color: #ccc;
  }

  &__hint {
    margin: 14px 0 0;
    font-size: 12px;
    color: #888;

    i {
      margin-right: 4px;
      color: #1ab394;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TransportRate/TransportRateGrid.vue